import React from 'react';
import PropTypes from 'prop-types';
import _ from "underscore";

// NOSONAR: `category` and `label` are Blockly toolbox-XML pseudo-elements,
// not real DOM elements. Attributes like `iconclass` and `text` are valid
// Blockly toolbox attributes.
const Variables = ({ blocks, context }) => {
    if (!context?.environmentVariables) return null;

    const childBlocks = _.map(blocks, ({ component: BlockComponent }, blockKey) => (
        <BlockComponent context={context} key={blockKey}/>
    ));

    if (!_.isEmpty(context.environmentVariables) && childBlocks.length > 0) {
        return (
            <category name='Global Variables' id='EnvVariables' iconclass='category with-icon-paths snap-icon-global_variable_dual'>{/* NOSONAR */}
                <label text="Global Variables"></label>{/* NOSONAR */}
                { childBlocks }
            </category>
        );
    }

    return null;
};

Variables.propTypes = {
    blocks: PropTypes.object.isRequired,
    context: PropTypes.object.isRequired,
};

export default Variables;
